import { API } from './apiWrapper';
import { useState } from 'react';

import { TSchoolSearchCondition, TSchool, ISearchRecord } from 'src/types';
import { processResponse } from 'src/utils/api';
import { OrgServiceFactory } from 'src/types/org';

const service = new OrgServiceFactory();
interface IFindSchool {
  orgId: string;
}

export const findSchool = async (find: IFindSchool) => {
  const data = await API.post('AiFormRequest', '/save?key=findOrg', {
    body: find,
  }).then(processResponse);
  return data;
};

export const searchSchools = async (searchData: TSchoolSearchCondition) => {
  const data = await API.post('AiFormRequest', '/save?key=match', {
    body: searchData,
  });
  return data;
};

const mapAI = (school: any): TSchool[] => {
  const searchData = school._source || {};
  const ais = searchData.ais || [];

  const mappedAIs: TSchool[] = ais.map((ai: any): TSchool => {
    const schoolInfo: TSchool = {
      orgId: school._source.org_id,
      aiCode: ai.ai_code,
      aiName: ai.ai_name ? ai.ai_name : school._source.org_full_name,
      orgName: school._source.org_full_name,
      orgAddress: school._source.org_street_addr1,
      orgCity: school._source.org_city,
      orgStateCode: school._source.org_state_cd,
      orgCountryCode: school._source.org_country_iso_cd,
      orgProvince: school._source.org_province,
      orgPostalCode: school._source.org_intl_postal_code,
      orgZip: school._source.org_zip5,
      aiStatus: ai.ai_status_cd,
      aiStatusCd: ai.ai_status_cd,
      aiLevelCd: ai.ai_level_cd,
      lowestGradeCd: school._source.lowest_ed_lvl_cd,
      highestGradeCd: school._source.highest_ed_lvl_cd
    };

    if (schoolInfo.aiStatus === '1') {
      schoolInfo.aiStatus = 'Inactive';
    } else if (schoolInfo.aiStatus === '2') {
      schoolInfo.aiStatus = 'Active';
    }
    if (!(school._source.org_country_iso_cd === 'US' || school._source.org_country_iso_cd === '')) {
      schoolInfo.orgZip = school._source.org_zip4;
    }

    return schoolInfo;
  });

  return mappedAIs;
};

const mapAISearch = (schools: any) => {
  const mapped: TSchool[][] = schools.map((school: any): TSchool[] => {
    return mapAI(school);
  });
  return mapped.flat();
};

export const useSearchAI = () => {
  const [isLoading, setLoading] = useState(false);
  const [failure, setError] = useState('');
  const [data, setData] = useState<ISearchRecord[]>([]);
  const [total, setTotal] = useState<number>(0);

  const search = async (params: TSchoolSearchCondition) => {
    setLoading(true);
    try {
      const searchResult = await searchSchools(params);
      const schools = searchResult?.hits?.hits || [];
      const ais = mapAISearch(schools);
      const orgIds: string[] = ais.map((school: TSchool) => {
        return school.orgId;
      });
      const records = await service.updateRequest.searchActive({ ids: orgIds });
      const active = records.active;
      const owned = records.owned;

      const results: ISearchRecord[] = [];
      for (const ai of ais) {
        const activeRequest = active.find((summary) => summary.orgId === ai.orgId);
        const ownedRequest = owned.find((summary) => summary.processStatus === 'submitted' && summary.orgId === ai.orgId);

        results.push({
          ai: ai,
          active: activeRequest,
          owned: ownedRequest
        });
      }
      setTotal(searchResult?.hits?.total || 0);
      setData(results);
    } catch (error: any) {
      setError(error.message);
    }
    setLoading(false);
  };

  return { isLoading, failure, total, data, search };
};
